// Provide support to 
//   var LiteMol = require('LiteMol').default
// and 
//   import LiteMol from 'LiteMol'

exports.__esModule = true;
exports.default = require('./dist/js/LiteMol-plugin')